import React, { Component } from "react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { connect } from "react-redux";
import CustomLoader from "../../forms/Loader";
import { reinitateTransaction } from "../../../store/actions";
import { AUTHORIZATION_PENDING } from "../../../store/types";
// import CustomLoading from "../CustomLoader";
import { FormatCurrency } from "../currencyFormatter";
import Signbutton from "../../forms/button";
import copy from "copy-to-clipboard";
import { addDays, isAfter } from "date-fns";

class TableContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    };
  }
  copyCodeToClipboard = (Link) => () => {
    copy(Link);
    alert("Link copied successfully");
  };
  reinitiate = async (item) => {
    try {
      this.setState({ loading: true });
      const { fund_code, ihno } = item;

      const params = { fund: fund_code, ihno };
      const response = await this.props.reinitateTransaction(params);

      if (!!response) {
        const data = response.Table1[0];
        const { IHNO } = data;
        alert(
          `Successfully Reinitiated Transaction with transaction number ${IHNO}`
        );
      }
    } catch (e) {
      alert(e);
    } finally {
      this.setState({
        loading: false,
      });
    }
  };
  displayTableRow = (item) => {
    if (this.props.active !== "P") {
      return isAfter(addDays(new Date(item.Entdate), 30), new Date());
    }
    return true;
  };
  displayButton = (item) => {
    if (this.props.active === "E") {
      return isAfter(addDays(new Date(item.Entdate), 14), new Date());
    }
    return true;
  };

  displaySummaryData = (summaryData = []) => {
    return summaryData.some((item) => this.displayTableRow(item));
  };
  render() {
    const { summaryData, active } = this.props;
    const showCopyButton = [AUTHORIZATION_PENDING].includes(active);
    return (
      <React.Fragment>
        <CustomLoader display={this.state.loading} />
        {!!summaryData.length && this.displaySummaryData(summaryData) ? (
          <Paper className="authorization-table">
            <Table className="Responsive-table">
              <TableHead>
                <TableRow>
                  <TableCell>INVESTOR</TableCell>
                  {/* <TableCell>CONTACT</TableCell> */}
                  <TableCell>FUND</TableCell>
                  <TableCell>TYPE</TableCell>
                  <TableCell>DATE</TableCell>
                  <TableCell>Ref No</TableCell>
                  <TableCell>AMOUNT/UNITS</TableCell>
                  <TableCell>
                    {" "}
                    {!!showCopyButton ? "Copy Link" :null}
                  </TableCell>
                  <TableCell />
                </TableRow>
              </TableHead>
              <TableBody>
                {summaryData.map((item, index) => (
                  <>
                    {this.displayTableRow(item) && (
                      <TableRow key={index}>
                        <TableCell className="table-cell ">
                          {item.InvName}
                        </TableCell>
                        {/* <TableCell className="table-cell">{item.mobile}</TableCell> d */}
                        <TableCell className="table-cell">
                          {item.scheme}
                        </TableCell>
                        <TableCell className="table-cell">
                          {item.trtype}
                        </TableCell>
                        <TableCell className="table-cell">
                          {item.Entdate}
                        </TableCell>
                        <TableCell className="table-cell">
                          {item.dd_appno}
                        </TableCell>
                        <TableCell
                          className="table-cell"
                          style={{ display: "flex", justifyContent: "center" }}
                        >
                          <FormatCurrency
                            value={
                              (item.trtype === "SIP"
                                ? item.sipamount
                                : item.amount) || 0
                            }
                          />
                          /{!!item.units ? item.units : 0}
                        </TableCell>
                        {this.displayButton(item) && (
                          <TableCell>
                            {active === "P" && (
                              <Signbutton
                                buttontitle={"Copy Transaction Link"}
                                fontSize={12}
                                padding={"4px 7px"}
                                onClick={this.copyCodeToClipboard(item.Link)}
                                marginTop={10}
                              />
                            )}
                          </TableCell>
                        )}
                      </TableRow>
                    )}
                  </>
                ))}
              </TableBody>
            </Table>
          </Paper>
        ) : this.props.count > 0 ? (
          <CustomLoader display={true} />
        ) : (
          <div
            style={{
              textAlign: "center",
              fontSize: 18,
              color: "red",
              marginTop: 20,
            }}
          >
            No Data Found
          </div>
        )}
        <div className="mobile-aum-list">
          {summaryData.length > 0 ? (
            summaryData.map((ele, index) => (
              <InvestorTableCard
                key={index}
                InvName={ele.InvName}
                Ref_No={ele.dd_appno}
                scheme={ele.scheme}
                type={ele.trtype}
                date={ele.Entdate}
                amount={ele.amount}
                sipamount={ele.sipamount}
                units={ele.units}
                item={ele}
                active={active}
                reinitiate={this.reinitiate}
                copyCodeToClipboard={this.copyCodeToClipboard}
              />
            ))
          ) : (
            <div
              style={{
                fontFamily: "SourceSansPro-SemiBold",
                fontSize: 14,
                textAlign: "center",
                color: "red",
              }}
            >
              {" "}
              No Data Found
            </div>
          )}
        </div>
      </React.Fragment>
    );
  }
}

export default connect(
  ({ dashboard, loading }) => {
    const { summaryData } = dashboard;
    const { count } = loading;
    return { summaryData, count };
  },
  { reinitateTransaction }
)(TableContainer);
export class InvestorTableCard extends Component {
  render() {
    const {
      InvName,
      Ref_No,
      scheme,
      type,
      date,
      sipamount,
      amount,
      units,
      item,
      active,
      reinitiate,
      copyCodeToClipboard,
    } = this.props;
    return (
      <div
        style={{
          background: "white",
          border: "1px solid red",
          padding: "7px 10px",
          margin: "10px 0px",
        }}
      >
        <div
          style={{
            color: "#005DAC",
            fontSize: 14,
            paddingBottom: 5,
            borderBottom: "1px solid red",
          }}
        >
          {scheme}
        </div>

        <div style={{ display: "flex", padding: "8px 0px" }}>
          <div style={{ flexGrow: 1, flexBasis: 0 }}>
            <div style={{ fontSize: 12 }}>Name</div>
            <div
              style={{
                fontSize: 13,
                color: "#194b7e",
              }}
            >
              {!!InvName ? InvName : "NA"}
            </div>
          </div>
          <div style={{ flexGrow: 1, flexBasis: 0 }}>
            <div style={{ fontSize: 12 }}>Date</div>
            <div
              style={{
                fontSize: 13,
                color: "#194b7e",
              }}
            >
              {!!date ? date : "NA"}
            </div>
          </div>
        </div>
        <div style={{ display: "flex", padding: "8px 0px" }}>
          <div style={{ flexGrow: 1, flexBasis: 0 }}>
            <div style={{ fontSize: 12 }}>Type</div>
            <div
              style={{
                fontSize: 13,
                color: "#194b7e",
              }}
            >
              {!!type ? type : "NA"}
            </div>
          </div>
          <div style={{ flexGrow: 1, flexBasis: 0 }}>
            <div style={{ fontSize: 12 }}>Ref No</div>
            <div
              style={{
                fontSize: 13,
                color: "#194b7e",
              }}
            >
              {!!Ref_No ? Ref_No : "NA"}
            </div>
          </div>
        </div>
        <div style={{ display: "flex", padding: "8px 0px" }}>
          <div style={{ flexGrow: 1, flexBasis: 0 }}>
            <div style={{ fontSize: 12 }}>Amount/Units</div>
            <div
              style={{
                fontSize: 13,
                color: "#194b7e",
              }}
            >
              <FormatCurrency
                value={(type === "SIP" ? sipamount : amount) || 0}
              />
              /{!!units ? units : 0}
            </div>
          </div>
          {/* <div style={{ flexGrow: 1, flexBasis: 0 }}>
            {active !== "A" ? (
              active === "E" ? (
                <Signbutton
                  buttontitle={"Reinitiate"}
                  fontSize={12}
                  padding={"4px 7px"}
                  marginTop={10}
                  onClick={() => {
                    reinitiate(item);
                  }}
                />
              ) : (
                <Signbutton
                  buttontitle={"Copy Transaction Link"}
                  fontSize={12}
                  padding={"4px 7px"}
                  onClick={copyCodeToClipboard(item.Link)}
                  marginTop={10}
                />
              )
            ) : null}
          </div> */}
        </div>
      </div>
    );
  }
}
